var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6524 2.34375C12.6524 1.56834 12.0215 0.9375 11.2461 0.9375H7.68028C7.48681 0.391844 6.96547 0 6.35434 0C5.74322 0 5.22187 0.391844 5.02841 0.9375H1.40625C0.630844 0.9375 0 1.56834 0 2.34375V3.75H0.625V16H12.0274V3.75H12.6524V2.34375H12.6524ZM11.2461 1.875C11.5046 1.875 11.7149 2.08528 11.7149 2.34375V2.8125H8.61597V1.875H11.2461ZM5.03019 1.875H5.88559V1.40625C5.88559 1.14778 6.09588 0.9375 6.35434 0.9375C6.61281 0.9375 6.82309 1.14778 6.82309 1.40625V1.875H7.6785V2.8125H5.03019V1.875ZM0.9375 2.8125V2.34375C0.9375 2.08528 1.14778 1.875 1.40625 1.875H4.09269V2.8125H0.9375ZM11.0899 15.0625H1.5625V3.75H11.0899V15.0625H11.0899Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76025 11H9.89219V11.9375H2.76025V11Z",
    fill: "#6F6F6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76025 8.8125H9.89219V9.75H2.76025V8.8125Z",
    fill: "#6F6F6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76025 6.625H9.89219V7.5625H2.76025V6.625Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTickets);
export default __webpack_public_path__ + "static/media/footer_tickets.f17d7ae136f95c16603d828ce698d29d.svg";
export { ForwardRef as ReactComponent };